/// API prefix for normal users.
export const API_PREFIX = '/admin-api'
export const WX_API_PREFIX = '/admin-api'

/// API prefix for administrators.
export const ADMIN_API_PREFIX = `${API_PREFIX}/blade-administer`;